import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const {
  personAddBegin,
  personAddSuccess,
  personAddErr,

  dailyworkAddBegin,
  dailyworkAddSuccess,
  dailyworkAddErr,

  personReadBegin,
  personReadSuccess,
  personReadErr,

  singlePersonReadBegin,
  singlePersonReadSuccess,
  singlePersonReadErr,

  personUpdateSuccess,
  personUpdateErr,
  personUpdateBegin,

  personWorkReadBegin,
  personWorkReadSuccess,
  personWorkReadErr,

  getemployeedataReadBegin,
  getemployeedataReadSuccess,
  getemployeedataReadErr,

  employeedataReadBegin,
  employeedataReadSuccess,
  employeedataReadErr,



  holidaysAddBegin,
  holidaysAddSuccess,
  holidaysAddErr,


  holidayUpdateBegin,
  holidayUpdateSuccess,
  holidayUpdateErr,

  holidayDeleteSuccess,
  holidayDeleteErr,
  holidayDeleteBegin,



} = actions;




const holidayDataDelete = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(holidayDeleteBegin());
      const response = await DataService.delete(`/holidays/delete/${id}`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(holidayDeleteSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(holidayDeleteSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(holidayDeleteSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(holidayDeleteErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};


const HolidayUpdateData = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(holidayUpdateBegin());
      const response = await DataService.put(`/holidays/update`, data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(holidayUpdateSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(holidayUpdateSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(holidayUpdateSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(holidayUpdateErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};


const HolidayDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(holidaysAddBegin());
      const response = await DataService.post('/holidays/create', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(holidaysAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(holidaysAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(holidaysAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(holidaysAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};





const personDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(personAddBegin());
      const response = await DataService.post('/person/create', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(personAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(personAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(personAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(personAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const personDataRead = (scope = null) => {
  return async (dispatch) => {
    try {
      await dispatch(personReadBegin());
      const url = scope ? `/person?scope=${encodeURIComponent(scope)}` : `/person`;
      const response = await DataService.get(url);
      // const response = await DataService.get(`/person`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(personReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(personReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(personReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(personReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const singlePersonDataRead = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(singlePersonReadBegin());
      let response;
      if (getItem('role') === 'EMPLOYEE') {
        response = await DataService.get(`/person/${id}`);
      } else {
        response = await DataService.get(`/admin/${id}`);
      }
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(singlePersonReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(singlePersonReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(singlePersonReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(singlePersonReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const personDataUpdate = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(personUpdateBegin());
      let response;
      if (getItem('role') !== 'ADMIN') {
        response = await DataService.blob('PUT', `/person/update`, data);
      } else {
        response = await DataService.put(`/person/update`, data);
      }
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(personUpdateSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(personUpdateSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(personUpdateSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(personUpdateErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};



const dialyWorkSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(dailyworkAddBegin());
      const response = await DataService.post('/dailywork/create', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(dailyworkAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(dailyworkAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(dailyworkAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(dailyworkAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};



const personWorkDataRead = (username, startDate, endDate) => {
  return async (dispatch) => {
    try {
      await dispatch(personWorkReadBegin());

      const u = username ? encodeURIComponent(username) : 'null';
      const sd = startDate || 'null';
      const ed = endDate || 'null';

      const response = await DataService.get(
        `/dailywork/employeedata/${u}/${sd}/${ed}`
      );

      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(personWorkReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(personWorkReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(personWorkReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(personWorkReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const employeenames = (scope = null) => {
  return async (dispatch) => {
    try {
      await dispatch(getemployeedataReadBegin());

      // const response = await DataService.get(`/person/employeenames`);
      const url = scope ? `/person/employeenames?scope=${encodeURIComponent(scope)}` : `/person/employeenames`;
      const response = await DataService.get(url);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(getemployeedataReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(getemployeedataReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(getemployeedataReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(getemployeedataReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const SingleEmployeeData = () => {
  return async (dispatch) => {
    try {
      await dispatch(employeedataReadBegin());
      const response = await DataService.get(`/dailywork`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(employeedataReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(employeedataReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(employeedataReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(employeedataReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

export {
  personDataRead,
  personDataSubmit,
  personDataUpdate,
  singlePersonDataRead,
  dialyWorkSubmit,
  personWorkDataRead,
  employeenames,
  SingleEmployeeData,
  HolidayDataSubmit,
  HolidayUpdateData,
  holidayDataDelete
};
